// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ExpandableToolbarButton:hover .ExpandableToolbarButton__arrow:after {\n  content: \"\";\n  position: absolute;\n  bottom: -10px;\n  border-width: 10px 10px 0;\n  border-style: solid;\n  border-color:#5acce6 transparent;\n}\n\n.ExpandableToolbarButton .ExpandableToolbarButton__content {\n  display: none;\n}\n\n.ExpandableToolbarButton:hover .ExpandableToolbarButton__content {\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
